import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
const AddGoalDetails = React.lazy(() => import("./AddGoalDetails"));
const ObjectiveDetails = React.lazy(() => import("./ObjectiveDetails"));
const Goal = React.lazy(() => import("./CreateGoal"));
export const GoalConfigs = [
    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.HR_MANAGER,
        ],
        path: "/performance/goal/:id",
        element: <AddGoalDetails />,
    },

    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.HR_MANAGER,
        ],
        path: "/performance/goal/:id/:id",
        element: <ObjectiveDetails />,
    },
    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.HR_MANAGER,
        ],
        path: "/performance/goal",
        element: <Goal />,
    },
];
